<template>
  <v-layout
    row
    wrap
    justify-center
    style="max-height: 40vh"
    class="scrollDesign"
  >
    <v-flex xs12 sm5 md4 lg3>
      <v-list subheader :three-line="flags.gEditing">
        <v-slide-y-transition group>
          <v-subheader key="subheader" inset>{{
            lvl.isExtra ? 'Actividad' : 'Grados'
          }}</v-subheader>
          <v-list-tile
            v-for="(item, index) in selected.grades"
            :key="item.name"
            avatar
            :class="
              'pa-0 mb-1' +
              (selected.sGrade.name == item.name
                ? ' selectedElement'
                : ' elevation-1 grey lighten-4')
            "
            style="border-radius: 5px"
            @click="selectGrade(item)"
            @dblclick="editGrade(item)"
          >
            <v-list-tile-avatar>
              <v-icon :color="lvl.isExtra ? 'secondary' : 'primary'" large>
                label
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <div v-if="flags.gEditing && selected.eGrade.name == item.name">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      :value="item.name"
                      v-model="formGrade.name"
                      required
                      :error-messages="gradeErrors"
                      v-show="
                        flags.gEditing && selected.eGrade.name == item.name
                      "
                      @blur.stop="updateGrade(item)"
                      @keyup.enter.native="updateGrade(item)"
                    ></v-text-field>
                  </template>
                  <span>Enter para guardar</span>
                </v-tooltip>
              </div>
              <v-list-tile-title v-else>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action
              v-if="flags.gEditing && selected.eGrade.name == item.name"
            >
              <v-btn icon ripple small @click="cancelEditGrade(item)">
                <v-icon color="primary"> cancel </v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-action v-else-if="userPermissions['DELETE_GG']">
              <v-btn icon ripple small>
                <v-icon
                  :color="lvl.isExtra ? 'secondary' : 'red'"
                  @click="deleteGrade(item, false)"
                >
                  delete
                </v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile
            v-for="(item, index) in nGrade"
            :key="item.name"
            :class="
              'pa-0 mb-1' +
              (selected.sGrade.name == item.name
                ? ' selectedElement'
                : ' elevation-1 grey lighten-5')
            "
            avatar
            style="border-radius: 5px"
          >
            <v-list-tile-avatar>
              <v-icon :color="lvl.isExtra ? 'secondary' : 'primary'" large>
                label
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content style="min-height: 7vh !important">
              <v-text-field
                :error-messages="gradeErrors"
                v-model="formGrade.name"
                @blur="createGG"
                label="Nombre"
                required
              ></v-text-field>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            key="new"
            avatar
            class="'pa-0 mb-1 elevation-1 grey lighten-5"
            style="border-radius: 5px"
            v-if="
              userPermissions['ADD_GG'] && !flags.gAdding && !flags.gEditing
            "
            @click="addGrade"
          >
            <v-list-tile-avatar>
              <v-icon :color="lvl.isExtra ? 'secondary' : 'primary'" large>
                add
              </v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Añadir</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-slide-y-transition>
      </v-list>
    </v-flex>
    <v-slide-x-transition>
      <v-flex
        xs12
        sm5
        md4
        lg3
        v-if="selected.sGrade.name != null || flags.gAdding"
        class="innerContainer"
      >
        <v-list subheader :three-line="flags.gEditing">
          <v-slide-y-transition group>
            <v-subheader key="subheader" inset>Grupos</v-subheader>
            <v-list-tile
              v-for="(item, index) in selected.sGrade.groups"
              :key="item.id"
              avatar
              class="'pa-0 mb-1"
              style="border-radius: 5px"
              @click
              @dblclick="editGroup(item)"
            >
              <v-list-tile-avatar>
                <v-icon :color="lvl.isExtra ? 'secondary' : 'primary'" large>
                  label_important
                </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-tooltip
                  bottom
                  v-if="flags.gEditing && selected.eGroup.id == item.id"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-if="userPermissions['UPDATE_GG']"
                      v-on="on"
                      :value="item.name"
                      v-model="formGroup.name"
                      required
                      :error-messages="groupErrors"
                      v-show="flags.gEditing && selected.eGroup.id == item.id"
                      @blur.stop="updateGroup(item)"
                      @keyup.enter.native="updateGroup(item)"
                    ></v-text-field>
                    <p v-else v-on="on">
                      {{ item.name }}
                    </p>
                  </template>
                  <span>Enter para guardar</span>
                </v-tooltip>
                <v-list-tile-title v-else>{{ item.name }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action
                v-if="
                  userPermissions['DELETE_GG'] &&
                  flags.gEditing &&
                  selected.eGroup.id == item.id
                "
              >
                <v-btn icon ripple small @click="cancelEditGroup(item)">
                  <v-icon :color="lvl.isExtra ? 'secondary' : 'primary'">
                    cancel
                  </v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-else-if="userPermissions['DELETE_GG']">
                <v-btn icon ripple small @click="deleteGroup(item, false)">
                  <v-icon :color="lvl.isExtra ? 'secondary' : 'red'">
                    delete
                  </v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              v-for="(item, index) in nGroup"
              :key="item.name"
              class="pa-0 mb-1"
              avatar
              style="border-radius: 5px"
            >
              <v-list-tile-avatar>
                <v-icon :color="lvl.isExtra ? 'secondary' : 'primary'" large>
                  label_important
                </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content style="min-height: 7vh !important">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      @keyup.enter.native="createGG"
                      @blur="createGG"
                      :error-messages="groupErrors"
                      v-model="formGroup.name"
                      label="Nombre"
                      required
                    ></v-text-field>
                  </template>
                  <span>Enter para guardar</span>
                </v-tooltip>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              key="new"
              avatar
              class="'pa-0 mb-1 white"
              style="border-radius: 5px"
              v-if="
                userPermissions['ADD_GG'] && !flags.gAdding && !flags.gEditing
              "
              @click="addGroup"
            >
              <v-list-tile-avatar>
                <v-icon :color="lvl.isExtra ? 'secondary' : 'primary'" large>
                  add
                </v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Añadir</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-slide-y-transition>
        </v-list>
      </v-flex>
    </v-slide-x-transition>
    <Confirm
      v-on:desition="
        flags.deleteFlag ? deleteGrade($event, true) : deleteGroup($event, true)
      "
      v-model="modals.confirmation"
      :title="modals.title"
      :description="modals.description"
    ></Confirm>
    <Alert
      :title="modals.title"
      :description="modals.description"
      v-model="modals.alert"
    ></Alert>
    <Notify
      v-model="modals.notify"
      :text="notify.text"
      :buttonText="notify.textButton"
    ></Notify>
  </v-layout>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Alert from '../../Dialogs/Alert'
import Confirm from '../../Dialogs/Confirm'
import Notify from '../../Dialogs/Notify'
export default {
  components: {
    Confirm,
    Alert,
    Notify,
  },
  validations: {
    formGrade: {
      name: {
        required,
        isUnique(value) {
          for (var g in this.selected.grades) {
            if (
              this.selected.grades[g].name == value &&
              g != this.formGrade.id
            ) {
              return false
            }
          }
          return true
        },
      },
    },
    formGroup: {
      name: {
        required,
        isUnique(value) {
          for (var g in this.selected.sGrade.groups) {
            if (
              this.selected.sGrade.groups[g].name == value &&
              this.selected.sGrade.groups[g].id != this.formGroup.id
            ) {
              return false
            }
          }
          return true
        },
      },
    },
  },
  props: ['groups', 'grades', 'lvl', 'sGrade', 'resetNew', 'userPermissions'],
  watch: {
    resetNew() {
      if (this.resetNew) {
        this.nGrade = []
        this.nGroup = []
        this.flags.gAdding = false
        this.$forceUpdate()
        this.$emit('resetNewChange')
      }
    },
    // permits() {
    //   this.$forceUpdate()
    // },
    sGrade() {
      this.selected.sGrade = this.sGrade
    },
    grades() {
      this.selected.grades = this.grades
      this.$forceUpdate()
    },
    groups() {
      this.selected.groups = this.groups
      this.$forceUpdate()
    },
  },
  data: () => ({
    selected: {
      grades: [],
      sGrade: {
        groups: [],
      },
      eGrade: {},
      eGroup: {},
      dGrade: {},
      dGroup: {},
    },
    nGrade: [],
    nGroup: [],
    flags: {
      gAdding: false,
      gEditing: false,
      changes: false,
      deleteFlag: false,
    },
    modals: {
      title: '',
      description: '',
      confirmation: false,
      alert: false,
      notify: false,
    },
    notify: {
      text: '',
      textButton: '',
    },
    formGrade: {
      name: '',
    },
    formGroup: {
      name: '',
    },
  }),
  methods: {
    editGrade(item) {
      if (this.userPermissions['UPDATE_GG'] && !this.flags.gEditing) {
        this.flags.gEditing = true
        this.selected.eGrade = item
        this.formGrade.name = item.name
        this.formGrade.id = this.selected.grades.indexOf(item)
      }
    },
    cancelEditGrade(item) {
      if (this.userPermissions['UPDATE_GG'] && this.flags.gEditing) {
        this.flags.gEditing = false
        this.selected.eGrade = {}
        this.formGrade.name = ''
        this.formGrade.id = null
      }
    },
    editGroup(item) {
      if (this.userPermissions['UPDATE_GG'] && !this.flags.gEditing) {
        this.flags.gEditing = true
        this.selected.eGroup = item
        this.formGroup.name = item.name
        this.formGroup.id = item.id
      }
    },
    cancelEditGroup(item) {
      if (this.userPermissions['UPDATE_GG'] && this.flags.gEditing) {
        this.flags.gEditing = false
        this.selected.eGroup = {}
        this.formGroup.name = ''
        this.formGroup.id = null
      }
    },
    selectGrade(grade) {
      if (!this.flags.gEditing) {
        for (var i in this.selected.grades) {
          if (this.selected.grades[i].name == this.selected.sGrade.name) {
            this.selected.grades[i].groups = this.selected.sGrade.groups
          }
        }
        this.selected.sGrade = grade
        this.flags.gAdding = false
        this.flags.gEditing = false
        this.nGrade = []
        this.nGroup = []
        this.$emit('selectGG', grade)
        this.$forceUpdate()
      }
    },
    addGrade() {
      var grade = {
        name: '',
        groups: [],
      }
      this.selected.sGrade = {}
      this.flags.gEditing = false
      this.$emit('clearN')
      this.$forceUpdate()
      this.flags.gAdding = true
      this.nGrade.push(grade)
      this.addGroup()
    },
    addGroup() {
      var group = {
        name: '',
      }
      this.flags.gAdding = true
      this.nGroup.push(group)
    },
    createGG() {
      this.flags.changes = true
      if (this.nGrade.length == 0) {
        this.$v.formGroup.$touch()
        if (!this.$v.formGroup.$invalid) {
          this.$emit('loading')
          var body = {
            entity: [
              {
                grade: this.selected.sGrade.name,
                group: this.formGroup.name,
              },
            ],
          }
          var json = JSON.stringify(body) // aqui tienes la lista de objetos en Json
          var obj = JSON.parse(json)
          this.$store
            .dispatch('gg/createGG', { obj: obj, id: this.lvl.id })
            .then((response) => {
              this.$emit('successCreateG', response)
              this.$v.$reset()
              this.nGrade = []
              this.nGroup = []
              this.formGroup = {
                name: '',
              }
              this.selected.sGrade.groups.push({
                id: response.data[0].entity.id,
                name: response.data[0].entity.group,
              })
              this.addGroup()
              this.$forceUpdate()
            })
            .catch((error) => {
              this.$emit('error')
            })
        }
      } else {
        this.$v.formGrade.$touch()
        this.$v.formGroup.$touch()
        if (!this.$v.formGrade.$invalid && !this.$v.formGroup.$invalid) {
          this.$emit('loading')
          var body = {
            entity: [
              {
                grade: this.formGrade.name,
                group: this.formGroup.name,
              },
            ],
          }
          var json = JSON.stringify(body) // aqui tienes la lista de objetos en Json
          var obj = JSON.parse(json)
          this.$store
            .dispatch('gg/createGG', { obj: obj, id: this.lvl.id })
            .then((response) => {
              this.$emit('succesCreate', response)
              this.selected.sGrade = {
                name: response.data[0].entity.grade,
                groups: [
                  {
                    id: response.data[0].entity.id,
                    name: response.data[0].entity.group,
                  },
                ],
                totalByGrade: 0,
              }
              this.$v.$reset()
              this.nGrade = []
              this.nGroup = []
              this.formGrade = {
                name: '',
              }
              this.formGroup = {
                name: '',
              }
              this.addGroup()
            })
            .catch((error) => {
              this.$emit('error')
            })
        }
      }
    },
    updateGrade(item) {
      console.log(item)
      this.$v.formGrade.$touch()
      if (!this.$v.formGrade.$invalid) {
        this.$emit('loading')
        var body = {
          entity: [],
        }
        for (var i = 0; i < item.groups.length; i++) {
          body.entity.push({
            id: item.groups[i].id,
            grade: this.formGrade.name,
            group: item.groups[i].name,
          })
        }
        console.log(item)
        var json = JSON.stringify(body) // aqui tienes la lista de objetos en Json
        var obj = JSON.parse(json)

        this.$store
          .dispatch('gg/updateGG', obj)
          .then((response) => {
            this.flags.gEditing = false
            this.selected.eGrade = {}
            item.name = this.formGrade.name
            this.formGrade.name = ''
            this.$v.$reset()
            this.$emit('success')
            this.modals.notify = true
            this.notify.text = 'Se actualizaron los alumnos vinculados al grado'
            this.notify.textButton = 'Aceptar'
          })
          .catch((error) => {
            this.$emit('error')
            console.log(error)
          })
      }
    },
    updateGroup(item) {
      this.$v.formGroup.$touch()
      if (!this.$v.formGroup.$invalid) {
        this.$emit('loading')
        var body = {
          entity: [
            {
              id: item.id,
              grade: this.selected.sGrade.name,
              group: this.formGroup.name,
            },
          ],
        }
        var json = JSON.stringify(body) // aqui tienes la lista de objetos en Json
        var obj = JSON.parse(json)
        this.$store
          .dispatch('gg/updateGG', obj)
          .then((response) => {
            this.flags.gEditing = false
            this.selected.eGroup = {}
            item.name = this.formGroup.name
            this.formGroup.name = ''
            this.$v.$reset()
            this.$emit('success')
            this.modals.notify = true
            this.notify.text = 'Se actualizaron los alumnos vinculados al grupo'
            this.notify.textButton = 'Aceptar'
          })
          .catch((error) => {
            this.$emit('error')
            console.log(error)
          })
      }
    },
    deleteGrade(item, flag) {
      if (flag) {
        if (item) {
          var errorC = 0
          this.$emit('loading')
          var count = 0
          for (var i in this.selected.dGrade.groups) {
            this.$store
              .dispatch('gg/deleteGG', this.selected.dGrade.groups[i].id)
              .then((response) => {
                count++
                this.$emit('reload')
                if (count == this.selected.dGrade.groups.length) {
                  this.$emit('success')
                  if (errorC > 0) {
                    this.modals.title = 'Aviso'
                    this.modals.description =
                      errorC +
                      ' registro(s) no se puedieron eliminar debido a que contienen alumnos en ellos'
                    this.modals.alert = true
                  }
                }
              })
              .catch((error) => {
                count++
                errorC++
                this.$emit('reload')
                if (count == this.selected.dGrade.groups.length) {
                  this.$emit('error')
                  if (errorC > 0) {
                    this.modals.title = 'Aviso'
                    this.modals.description =
                      errorC +
                      ' grupo(s) no se puedieron eliminar debido a que contienen alumnos en ellos'
                    this.modals.alert = true
                  }
                }
                console.log(error)
              })
          }
        }
      } else {
        this.selected.dGrade = item
        this.modals.title = 'Aviso'
        this.modals.description =
          '¿Estas seguro que deseas eliminar este grado?'
        this.modals.confirmation = true
        this.flags.deleteFlag = true
      }
    },
    deleteGroup(item, flag) {
      if (flag) {
        if (item) {
          this.$emit('loading')
          this.$store
            .dispatch('gg/deleteGG', this.selected.dGroup.id)
            .then((response) => {
              this.$emit('success')
              this.selected.sGrade.groups.splice(
                this.selected.sGrade.groups.indexOf(this.selected.dGroup),
                1
              )
              if (this.selected.sGrade.groups.length == 0) {
                this.$emit('reload')
              }
            })
            .catch((error) => {
              this.$emit('error')
              this.modals.title = 'Aviso'
              this.modals.description =
                'el grupo no se pudo eliminar debido a que contiene alumnos en el'
              this.modals.alert = true
              console.log(error)
            })
        }
      } else {
        this.selected.dGroup = item
        this.modals.title = 'Aviso'
        this.modals.description =
          '¿Estas seguro que deseas eliminar este grupo?'
        this.modals.confirmation = true
        this.flags.deleteFlag = false
      }
    },
  },
  computed: {
    gradeErrors() {
      const errors = []
      if (!this.$v.formGrade.name.$dirty) return errors
      !this.$v.formGrade.name.required && errors.push('Requerido')
      !this.$v.formGrade.name.isUnique && errors.push('Repetido')
      return errors
    },
    groupErrors() {
      const errors = []
      if (!this.$v.formGroup.name.$dirty) return errors
      !this.$v.formGroup.name.required && errors.push('Requerido')
      !this.$v.formGroup.name.isUnique && errors.push('Repetido')
      return errors
    },
  },
}
</script>

<style></style>
